<template>
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="modal_size md_size">
                <a href="javascript:" class="ui_close" type="button" @click="$emit('close')">
                    <span class="sr_only"></span>
                </a>
                <dl class="modal_content">
                    <dt class="ellipsis">
                        <i>Image Cloud</i>
                    </dt>
                    <dd>
                        <div class="srchModal_wrap">
                            <dl class="dl_search">
                                <dd class="clearable" data-input-type="input">
                                    <span class="clearable">
                                        <input
                                            type="text"
                                            class="text_input"
                                            placeholder="Enter a file name or hashtag"
                                            v-clearable
                                            v-model="searchName"
                                        />
                                    </span>
                                </dd>
                                <dd class="btn">
                                    <a href="javascript:" class="btn_srch" @click="onSearch(1)">
                                        {{ $t('BUTTON.GLOBAL.SEARCH') }}
                                    </a>
                                </dd>
                            </dl>
                        </div>

                        <ul class="hashtag_list">
                            <li v-for="item in keyword" :key="item.KEY_WORD + item.HIT_COUNT + item.REG_DT">
                                <a href="javascript:" @click="searchKeyword(item.KEY_WORD)">{{ item.KEY_WORD }}</a>
                            </li>
                        </ul>
                        <!-- Grid -->
                        <toast-grid
                            :gridId="gridId"
                            :columns="columns"
                            :data="gridData"
                            :options="options"
                            :ref="gridId"
                            :key="gridKey"
                            :isTotalCount="false"
                            :click="contentClick"
                        />
                        <div class="paginate">
                            <sdl-pagination
                                align="center"
                                :current-page="currentPage"
                                :total-rows="totalCount"
                                :per-page="nRecordsPerPage"
                                @change="onSearch"
                            />
                        </div>

                        <div class="tooltip_wrap fl_right">
                            <em class="ico_info_lg">
                                <i class="tooltip fl_right">
                                    Important content, 7 days of search results at the top of the search result when
                                    selected/in the main. Default not selected.
                                </i>
                                <span class="sr_only">info</span>
                            </em>
                        </div>
                    </dd>
                </dl>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import qs from 'query-string';
import Vue from 'vue';
import api from '@/service';
import axios from 'axios';
import store from '@/vuex/store';
import SDLUtil from '@/utils/SDLUtil';
import { mapActions, mapGetters } from 'vuex';

import ToastGrid from '~c/ToastGrid';
import SDLPagination from '~~c/control/pagination/Pagination';
import SKPBreadcrumbs from '~vb/main/SKPBreadcrumbs';

export default {
    name: 'imageCloudList',
    components: {
        'skp-breadcrumbs': SKPBreadcrumbs,
        'toast-grid': ToastGrid,
        'sdl-pagination': SDLPagination,
    },
    props: {
        search: { default: '' },
        rtnFunc: {
            type: Function,
        },
    },
    data() {
        return {
            pageName: 'imageCloudList',
            pageTitle: '',
            searchName: '',
            category1Code: '',
            category2Code: '',
            category3Code: '',
            category1CodeList: [],
            category2CodeList: [],
            category3CodeList: [],
            keyword: [],
            totalCount: 0,
            currentPage: 1,
            nRecordsPerPage: Number(localStorage.getItem('listRows')),
            gridKey: 0,
            gridId: 'imageCloudListGrid',
            columns: [
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.CATEGORY'),
                    name: 'CATEGORY_NM',
                    align: 'center',
                    // width: 75,
                    resizable: true,
                    sortable: false,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.SUBJECT'),
                    name: 'TITLE',
                    align: 'center',
                    // width: 125,
                    resizable: true,
                    sortable: false,
                },
                {
                    header: 'File Format',
                    name: 'FILE_FORMAT',
                    align: 'center',
                    // width: 75,
                    resizable: true,
                    sortable: false,
                },
                {
                    header: 'File Size',
                    name: 'FILE_SIZE',
                    align: 'center',
                    // width: 375,
                    resizable: true,
                    sortable: false,
                },
                {
                    header: SDLUtil.getMsgProp('BUTTON.NOTICE.PREVIEW'),
                    name: 'PRE_VIEW',
                    align: 'center',
                    // width: 175,
                    resizable: true,
                    sortable: false,
                },
            ],
            gridData: [],
            options: {
                scrollY: true,
                scrollX: true,
                minBodyHeight: 80,
                bodyHeight: 450,
            },
        };
    },
    mounted() {
        this.searchName = this.search;
        this.categoryList(1);
        this.onSearch(1);
    },
    computed: {
        ...mapGetters({
            deptLevelCd: 'getDeptLevelCd',
            curLoginNo: 'getLoginNo',
            roles: 'getRoles',
            menus: 'getMenus',
            corpCd: 'getCorpCd',
        }),
    },
    methods: {
        searchKeyword(v) {
            this.searchName = v;
            this.onSearch(this.currentPage);
        },
        async onSearch(v) {
            //TODO 이국현프로님 증정
            let searchName = this.searchName.split(' ').filter(s => s.length > 0);
            searchName.push(this.searchName);

            SDLUtil.showLoadingBar(true);
            return await axios
                .post(
                    `${SDLUtil.API_URL}/basis/admin/imageCloud/imageList.skp`,
                    qs.stringify({
                        page: v,
                        searchName: searchName,
                        category1: this.category1Code,
                        category2: this.category2Code,
                        category3: this.category3Code,
                    }),
                )
                .then(resp => {
                    this.gridData = resp.data.result;
                    this.keyword = resp.data.search.keyword.rowData;
                    for (const iterator of this.gridData) {
                        if (0 === iterator.attach.rowData.length) {
                            iterator.PRE_VIEW = '<img src="/static/images/ico_preview.png">';
                        } else {
                            let url = this.getDownloadUrl(
                                iterator.attach.rowData[0].ENC_ATTCH_FILE_SEQ,
                                iterator.attach.rowData[0].ENC_TOKEN,
                            );
                            iterator.crossUrl =
                                `${SDLUtil.API_URL}/skp_files/skp_attach` +
                                iterator.attach.rowData[0].FILE_DIR.split('skp_attach')[1].replace(/\\/gi, '/');
                            iterator.PRE_VIEW =
                                '<a href="' +
                                iterator.crossUrl +
                                '" target="_blank"><img src="/static/images/ico_preview.png"></a>';
                        }
                    }

                    this.totalCount = resp.data.search.totalRecords;
                    this.currentPage = Number(resp.data.search.page);
                    this.gridKey++;
                    SDLUtil.showLoadingBar(false);
                })
                .catch(err => {
                    Vue.$log.error(err);
                    SDLUtil.errorAlert(err);
                    SDLUtil.showLoadingBar(false);
                });
        },
        async categoryList(v) {
            let codeCategoryId = '';
            let parentCode = '';
            if (v === 1) {
                codeCategoryId = 'ADM_CATEGORY_A';
                parentCode = '0';
                this.category1Code = '';
                this.category2Code = '';
                this.category3Code = '';
                this.category1CodeList = [];
                this.category2CodeList = [];
                this.category3CodeList = [];
                await this.getCodeComboList(parentCode, codeCategoryId, this.corpCd).then(resp => {
                    this.category1CodeList = resp;
                });
            } else if (v === 2) {
                codeCategoryId = 'ADM_CATEGORY_B';
                parentCode = this.category1Code;
                this.category2Code = '';
                this.category3Code = '';
                this.category2CodeList = [];
                this.category3CodeList = [];
                await this.getCodeComboList(parentCode, codeCategoryId, this.corpCd).then(resp => {
                    this.category2CodeList = resp;
                });
            } else if (v === 3) {
                codeCategoryId = 'ADM_CATEGORY_C';
                parentCode = this.category2Code;
                this.category3Code = '';
                this.category3CodeList = [];
                await this.getCodeComboList(parentCode, codeCategoryId, this.corpCd).then(resp => {
                    this.category3CodeList = resp;
                });
            }
        },
        async getCodeComboList(categoryVal, categoryCode, addCondition) {
            const codeResp = await api.getComboList(categoryVal, categoryCode, addCondition);
            return codeResp;
        },
        pageMove() {
            return this.$router.push({ name: 'imageCloudDetail' });
        },
        contentClick(e, rowData, grid) {
            console.log(e, rowData, grid);
            if (e.columnName === 'PRE_VIEW') return;
            this.rtnFunc(rowData[e.rowKey]);
            this.$emit('close');
        },
        getDownloadUrl(SEQ, TOKEN) {
            let cmnApiBase = `${SDLUtil.API_URL}/basis/common/attachDownload.skp`;
            return cmnApiBase + '?attachFileSeq=' + SEQ + '&encToken=' + TOKEN;
        },
    },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/skpComponents/view/admin/tool/imageCloudListPopup.vue